import {
  baseVendorApiSettingsDefaults,
  defaultHttpAgentSettings,
  defaultRateLimitationSettings,
  defaultSessionSettings,
  defaultVendorApiHttpAdvancedSettings,
} from './base';
import type { HttpBasedSessionVendorApiSettingsDefaults } from './types';

export const checkpointDefaults: HttpBasedSessionVendorApiSettingsDefaults = {
  ...baseVendorApiSettingsDefaults,
  ...defaultHttpAgentSettings,
  ...defaultRateLimitationSettings,
  ...defaultSessionSettings,
  ...defaultVendorApiHttpAdvancedSettings,
  maxConcurrentRequests: 1000,
};
